import {getResource} from "./common"

export type GettingStartedAttributes = {
	setupAuthentication: boolean
	embedTheComponent: boolean
	setupPrefill: boolean
}

export type ReadyToLaunchStatus = {
	type: "readyToLaunchSetupProgress"
	id: string
	attributes?: GettingStartedAttributes
}

export const getReadyToLaunchStatus = async (accessToken: string) =>
	await getResource<ReadyToLaunchStatus>(`white-label/ready-to-launch-status`, accessToken)
